import { ColorType, VariantClassesProps } from '../../utils'
import { LabelSize, LabelVariant } from './Label.types'

// Main style getters
/** Base styles for primary label variant */
export const getColorClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary: 'text-color-base',
        error: 'text-error',
        success: 'text-success',
        warning: 'text-warning',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Size getters for label component */
export const getSizeClasses = (size: LabelSize): string => {
    const sizeClasses: VariantClassesProps = {
        sm: 'text-2xs',
        base: 'text-2xs',
        md: 'text-xs',
        lg: 'text-xs',
    }

    return sizeClasses[size] || sizeClasses.md // Default size: md
}

/** Styles getters for contained label variant */
export const getContainedClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary:
            'dark:!text-color-text-light !text-color-label-dark font-bold leading-tight',
        error: 'dark:!text-color-text-light text-color-label-dark font-bold',
        success: 'dark:!text-success !text-success',
        warning: 'dark:text-warning !text-warning',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Styles getters for link label variant */
export const getLinkClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary: 'text-color-dark',
        error: '!text-error',
        success: 'text-success',
        warning: 'text-warning',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Styles getters for outlined label variant */
export const getOutlinedClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary: 'text-color-dark border-primary',
        error: 'text-error border-error',
        success: 'text-success border-success',
        warning: 'text-warning border-warning',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Variant styles controller */
export const getVariantClasses = (
    color: ColorType,
    variant: LabelVariant
): string => {
    const variantClasses: VariantClassesProps = {
        link: getLinkClasses(color),
        text: getColorClasses(color),
        contained: getContainedClasses(color),
        primary: getContainedClasses(color),
    }

    return variantClasses[variant] || variantClasses.primary // Default color: primary
}
